import { GuestUsageErrors, JoinEventErrors } from "./constants";

interface EventError {
  notification: string;
  action?: "EVENT_FULL" | "EVENT_ENDED";
}
export const getErrorMessage = (error: string): EventError => {
  switch (error) {
    case JoinEventErrors.EVENT_FULL: {
      return {
        notification: "eventLanding:event.full.try.again",
        action: JoinEventErrors.EVENT_FULL,
      };
    }
    case GuestUsageErrors.GUEST_LIMIT_EXCEEDED:
    case GuestUsageErrors.NO_ADDON: {
      return { notification: "common:attendee.limit.error" };
    }
    case JoinEventErrors.EVENT_PRIVATE:
    case JoinEventErrors.EVENT_UPCOMING:
      return {
        notification: error,
      };
    case JoinEventErrors.EVENT_ENDED: {
      return {
        notification: error,
        action: "EVENT_ENDED",
      };
    }
    default:
      return { notification: "server:unhandled.error" };
  }
};
